export default __webpack_public_path__ + "static/media/942.1bd30321.svg";